import { KahunConfigurationRoot } from "../configuration/root";
import {
  ConfigurationDottedKey,
  getAllConfigurationMetaData,
  ConfigOptionMetadata,
  keyToPath,
  getMetadataContainerForClass,
  ConfigMetaData,
} from "./annotations";

export function getConfigurationMetaDataForKey(
  key: ConfigurationDottedKey,
  root: any = KahunConfigurationRoot,
) {
  return getAllConfigurationMetaData(root, keyToPath(key), false);
}

export function getConfigurationMetaDataFlat(
  root: any = KahunConfigurationRoot,
  includeSubObjects = false,
): ConfigOptionMetadata[] {
  return getAllConfigurationMetaData(root, [], true, includeSubObjects) as any;
}

export function getConfigurationMetaDataForSubObjectClass(
  clazz: Function | Object,
) {
  return getMetadataContainerForClass(clazz, true) as ConfigMetaData[];
}

export function printConfig() {
  const configs = getConfigurationMetaDataFlat();
  const table = configs.map((c) => ({
    key: c.key,
    store:
      `${c.isMap ? "map of " : ""}${c.isArray ? "array of " : ""}` +
      c.storeType,
    display:
      `${c.isMap ? "map of " : ""}${c.isArray ? "array of " : ""}` +
      c.displayType,
    default: c.defaultValue,
  }));
  console.table(table);
}
